interface GenericChartData {
  title: string;
  count_line1: number;
  count_line2: number;
}

export const sortMonthYear = (data: GenericChartData[]) => {
    const months = [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'abr',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez',
      ];
    
      const sortedData = data.sort((a, b) => {
        if (a.title.split("/")[1] !== b.title.split("/")[1]) {
          return Number(a.title.split('/')[1]) - Number(b.title.split('/')[1]);
        }
    
        return (
          months.indexOf(a.title.split('/')[0]) - months.indexOf(b.title.split('/')[0])
        );
      });

      return sortedData;
};
